export const contactDetailsOne = [
  {
    title: "PAC Asset Management",
    number: "+234 700 909 909",
    email: "info@pacassetmanagement.com",
  },
  {
    title: "PAC Registrars",
    number: "+234 908 6790 272",
    email: "info@pacregistrars.com",
  },
  /* {
    title: "Keynes Private Equity",
    number: "+234 01 271 6000",
    email: "info@keynesprivateequity.com",
  }, */
  {
    title: "Kaxal Africa",
    number: "+234 807 809 5798",
    email: "info@webzenagroallied.com",
  },
  {
    title: "Afrilife Healthcare Services",
    number: "+234 806 489 7887",
    email: "info@afrilifehealthcare.com",
  },
];

export const contactDetailsTwo = [
  {
    title: "PAC Trustees",
    number: "+234 1 280 1266",
    email: "info@pactrustees.com",
  },
  {
    title: "PAC Capital",
    number: "+ 234 01 277 0394",
    email: "info@paccapitalltd.com",
  },
  {
    title: "Amber Hospitality Services",
    number: "+234 1 422 0004",
    email: "info@amberhospitality.com",
  },
  {
    title: "Tergo Energy",
    number: "+234 1 4227777",
    email: "info@tergoenergy.com",
  },
  {
    title: "PAC Foundation",
    number: "+234 913 933 8254",
    email: "info@panafricancapitalholdings.com",
  },
];

export const contactDetailsThree = [
  {
    title: "PAC Securities",
    number: "+234 803 7179 556",
    email: "info@pacsecurities.com",
  },
  {
    title: "Factoring & Supply Chain Finance",
    number: "+234 1 422 7886",
    email: "Info@fscfng.com",
  },
  {
    title: "BRICS Property And Infrastructure",
    number: "+234 1 280 1266",
    email: "info@bricsinfrastructure.com",
  },
  {
    title: "Ziltch1 Technologies",
    number: "+234 1 903 044 2365",
    email: "info@ziltchone.com",
  },
];
